<template>
  <form class="version version-4" name="step4_2">
    <input type="hidden" name="landing_type" value="cash">
    <div class="input-group_title">
      <h4>{{__t('Дані про працевлаштування')}}</h4>
    </div>
    <div class="form-wrap_group version-4_group fw">
      <div class="input-field">
        <label>
          <p>{{__t('Тип занятості')}}</p>
          <div class="input-wrap">
            <input type="text" :placeholder="__t('Пенсіонер')" disabled>
          </div>
        </label>
      </div>
      <div class="input-field">
        <label>
          <p>{{__t('Коли вийшли на пенсію?')}}</p>
          <div class="input-wrap">
            <input type="tel" name="employer_last_work_date" v-mask="'##.##.####'" placeholder="ДД.ММ.РРРР">
            <div class="input-info_btn">
              <img src="/img/cash-credit-landing/info-btn.svg">
              <div class="input-info_popup">
                <p>{{__t('Подсказка дата выхода на пенсию')}}</p>
              </div>
            </div>
          </div>
        </label>
      </div>
    </div>
    <div class="input-group_title">
      <h4>{{__t('Дані про доходи')}}</h4>
    </div>
    <div class="form-wrap_group fw">
      <div class="input-field">
        <label>
          <p>{{__t('Офіційний місячний дохід, грн')}}</p>
          <div class="input-wrap">
            <input  type="number"
                    name="official_income"
                    :placeholder="__t('Введіть сумму')"
                    v-numericOnly pattern="^[0-9]+$"
                    v-model="official_income">
            <div class="input-info_btn input-info-wrap">
              <img src="/img/cash-credit-landing/info-btn.svg">
              <div class="input-info_popup">
                <p>{{__t('Підказка офіційний місячний дохід - cash - частина-1')}}</p>
                <p>{{__t('Підказка офіційний місячний дохід - cash - частина-2')}}</p>
              </div>
            </div>
          </div>
        </label>
      </div>
      <div class="input-field">
        <label>
          <p>{{__t('Сукупний місячний дохід, грн')}}</p>
          <div class="input-wrap">
            <input type="number" name="unconfirmed_income"
                  :placeholder="__t('Введіть сумму')"
                  v-numericOnly pattern="^[0-9]+$"
                  v-model="unconfirmed_income">
            <div class="input-info_btn">
              <img src="/img/cash-credit-landing/info-btn.svg">
              <div class="input-info_popup">
                <p>{{__t('Подсказка общий месячный доход')}}</p>
              </div>
            </div>
          </div>
        </label>
      </div>
    </div>

    <div class="button-group">
      <button type="button"
              @click.submit.prevent="goBack"
              class="popup-button btn green-btn colored-btn">
        {{__t('Повернутись назад')}}
      </button>
        <div class="button-wrapper page-bottom ">
          <button type="submit" class="btn red-btn">{{__t('Відправити заявку')}}</button>
        </div>
    </div>

  </form>
</template>

<script>
    export default {
        name: "type_activity-2",
        data: () => ({
          official_income: '',
          unconfirmed_income: '',
        }),
        watch: {
          official_income(newVal) {
            this.official_income = newVal.replace(/\D/g, '') || '';
          },
          unconfirmed_income(newVal) {
            this.unconfirmed_income = newVal.replace(/\D/g, '') || '';
          }
        },
        methods: {
            __t(phrase) {
                return window.__t(phrase);
            },
            goBack() {
                this.$emit('goback');
                return false;
            },
            goNext() {
                this.$emit('gonext');
                return false;
            },

            validation: function () {
                let self = this;


                let form = $('[name=step4_2]').validate({
                    rules: {
                        employer_last_work_date: {
                            required: true,
                            regDay: true
                        },
                        official_income: {
                            required: true,
                        },
                        unconfirmed_income: {
                            required: true,
                        }
                    },
                    messages: {
                        employer_last_work_date: {
                            required: __t('Це поле обов’язкове. Заповніть його'),
                        },
                        official_income: {
                            required: __t('Це поле обов’язкове. Заповніть його'),
                        },
                        unconfirmed_income: {
                            required: __t('Це поле обов’язкове. Заповніть його'),
                        },
                    },
                    errorPlacement: function (error, element) {
                        error.insertAfter(element);
                    },
                    submitHandler: function (form) {

                        var data = $('[name=step4_2]').serializeArray();

                        self.$emit('openPreloader');

                        jQuery.ajax({
                          headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                          },
                            data: data,
                            type: "POST",
                            url: '/cash/step4',
                            cache: false,
                            dataType: "json",
                            success: function (response) {
                                if (response.status == 'refusing') {
                                    self.$emit('error');
                                } else if (response.status == 'callback') {
                                    self.$emit('call');
                                } else {
                                    self.$emit('success');
                                }
                                self.$emit('closePreloader');
                                // self.$emit('returnbegin');
                            },
                            error: function (error) {
                                self.errorValidation = error.responseJSON;
                                self.$emit('closePreloader');
                            }
                        });

                    }
                });
            }

        },
        mounted() {
            this.validation();

            $('.input-info_btn').on('mouseover', function (el) {
              this.querySelector('.input-info_popup').style.visibility = "visible";
            });


            $('.input-info_btn').on('mouseout', function (el) {
              this.querySelector('.input-info_popup').style.visibility = "hidden";
            });
        }
    }
</script>


